import React from 'react';
import { useTransition, animated } from 'react-spring';

interface AnimatedContainerProps {
  id: string;
  children: React.ReactNode;
  skipAnimation?: boolean;
}

export const AnimatedContainer: React.FC<AnimatedContainerProps> = ({ id, children, skipAnimation }) => {
  const transitions = useTransition({ id, node: children }, item => item.id, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 260, friction: 120 },
    immediate: skipAnimation,
  });

  return (
    <>
      {transitions.map(({ item, key, props }) => (
        <animated.div
          key={key}
          style={{
            position: 'absolute',
            pointerEvents: 'none',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            height: '100vh',
            ...props,
          }}
        >
          {item.node}
        </animated.div>
      ))}
    </>
  );
};
